export const ILISKI_SINEM = [
  {
    id: "is001",
    metin: "{{ad}}, otur karşıma şöyle. Bu iki yüze baktım ve anladım — {{soru}} konusunda asıl mesele yüzeysel değil. Derinlerde bir şeyler var. Aşk var, evet. Ama aşkın altında ne var? Onu bulmak lazım.\n\nO derine inme cesaretini bulun. Yüzeyde kalmak ilişkiyi korumaz, sadece erteler. Gerçek ilişkiler derinlikte kurulur — orada çalışın.",
    tema: "derinlik"
  },
  {
    id: "is002",
    metin: "{{ad}}, bu ilişkiye baktım. {{soru}} konusunda şunu söyleyeyim: biri çok veriyor, az alıyor. Bu denge sağlıklı değil. İlişkide vermek güzel ama kendini boşaltmak yok etmektir.\n\nSınır koy. 'Bu kadar verebilirim' demek ilişkiyi zayıflatmaz — korur. Çünkü tükenen biri ne kendine ne de ilişkisine verebilir. Önce kendini doldur.",
    tema: "sinir"
  },
  {
    id: "is003",
    metin: "{{ad}}, bu iki insanın arasında köklü bir bağ var. {{soru}} konusunda bu bağ kolay kolay kopmaz — ama ihmal edilirse solar.\n\nSulayın bu çiçeği. Her gün biraz — küçük bir söz, bir dokunuş, bir 'seni düşündüm.' Büyük jestler değil, tutarlı özen. Bağ bunlarla yaşar.",
    tema: "bag"
  },
  {
    id: "is004",
    metin: "{{ad}}, bu ilişkide iletişim sorunu var. Net görüyorum. {{soru}} konusunda söylenmesi gereken şeyler söylenmiyor — bunlar birikiyor.\n\nBirikim zamanla patlama yapar. Konuşun, şimdi konuşun. Doğru an diye bir şey yoktur — doğru niyet vardır. Niyetiniz iyiyse, şimdi başlayın.",
    tema: "iletisim"
  },
  {
    id: "is005",
    metin: "{{ad}}, bu iki yüzün enerjisine baktım. {{soru}} konusunda biri sıcak, biri soğuk. Uyumsuzluk değil bu — farklı sevgi dilleri.\n\nBirbirinizin dilini öğrenin. Biri dokunuşla, biri sözle, biri eylemle sever. O farkı anlamak, her şeyi değiştirir. Yanlış dilde sevgi göstermek karşı tarafa ulaşmaz.",
    tema: "sevgi_dili"
  },
  {
    id: "is006",
    metin: "{{ad}}, bu ilişkide geçmişin ağırlığı var. {{soru}} konusunda eski yaralar kapanmadan yeni bölümler tam başlamıyor.\n\nO yarayı sarın — birlikte. Eski kırgınlıkları konuşun, yargılamadan dinleyin. İyileşme için önce yüzleşmek gerekir. Acıtır ama gereklidir.",
    tema: "iyilesme"
  },
  {
    id: "is007",
    metin: "{{ad}}, bu iki insana baktım — ikisi de gurur taşıyor. {{soru}} konusunda gurur ilişkilerin en sessiz ama en etkili yıkıcısıdır.\n\nKim önce uzanacak? O adımı atan güçsüz değil, güçlüdür. Bugün o cesareti gösterin. 'Ben hata yaptım' veya 'özür dilerim' demek — bu cümleler dünyaları değiştirir.",
    tema: "gurur"
  },
  {
    id: "is008",
    metin: "{{ad}}, bu ilişkide üçüncü bir enerji var — dış baskı. {{soru}} konusunda o dış etki ilişkiyi zorluyor.\n\nBuna karşı birlikte durun. Dışa karşı birlik, içe karşı dürüstlük — ilişkiyi bu ikisi korur. Başkalarının yorumlarına değil, birbirinize kulak verin.",
    tema: "dis_etki"
  },
  {
    id: "is009",
    metin: "{{ad}}, bu iki insanın gözlerine baktım. {{soru}} konusunda birinin gözünde soru var, öbürünün gözünde cevap. Ama cevap olan söylemiyor.\n\nNeden söylemiyor? Korku mu, kibir mi? Her ikisi de ilişkiye zarar verir. Güvenli bir ortam yaratın — o ortamda cevaplar kendiliğinden konuşur.",
    tema: "korku"
  },
  {
    id: "is010",
    metin: "{{ad}}, bu ilişkide güven meselesi var. {{soru}} konusunda güveni kıran bir şey olmuş — belki küçük, belki büyük.\n\nKırık güven onarılabilir, ama zaman ve çaba ister. Onarım süreci acıtır — ama onarılmış güven çok daha sağlamdır. İstek varsa, başlamak için çok geç değil.",
    tema: "guven"
  },
  {
    id: "is011",
    metin: "{{ad}}, bu ilişkiye baktım ve şunu gördüm: iki insan da değişiyor. {{soru}} konusunda değişim ilişkiyi zorluyor.\n\nAma değişim kaçınılmaz — önemli olan birlikte değişmek. 'Sen değiştin' yerine 'biz birlikte değişiyoruz, bu normal' demek — çok farklı bir atmosfer yaratır.",
    tema: "degisim"
  },
  {
    id: "is012",
    metin: "{{ad}}, bu iki yüzün enerjisi bana şefkat gösteriyor — ama yanlış yöne akan şefkat. {{soru}} konusunda birbirinize gösterdiğiniz şefkati kendinize de gösterin.\n\nYorulmuşsunuz. İkisi de. Kendinize nazik olun — çünkü içi boş biri dışarıya veremez. Dolun, sonra verin.",
    tema: "sefkat"
  },
  {
    id: "is013",
    metin: "{{ad}}, bu ilişkide romantizm azalmış — gündelik hayatın içinde kaybolmuş. {{soru}} konusunda o küçük dokunuşları, anlık bakışları hatırlayın.\n\nBüyük jestler değil, küçük anlar ilişkiyi besler. Bu hafta küçük bir şey yapın — bir not, bir sürpriz, beklenmedik bir 'seni seviyorum.' Küçük şeyler büyük farklar yaratır.",
    tema: "romantizm"
  },
  {
    id: "is014",
    metin: "{{ad}}, bu iki insanın arasındaki güç dengesine baktım. {{soru}} konusunda biri daha baskın, öbürü daha boyun eğen.\n\nSağlıklı ilişkide güç dengeli paylaşılır. Bu denge nerede bozuldu? Onu bulun. 'Ben şunu hissediyorum' diye başlayan cümleler suçlamadan çok daha etkilidir.",
    tema: "guc_dengesi"
  },
  {
    id: "is015",
    metin: "{{ad}}, bu ilişkide kıskançlık var. {{soru}} konusunda kıskançlık sevginin değil güvensizliğin göstergesi.\n\nO güvensizliğin kaynağı nerede? Dışarıda değil, içeride ara. Güveni konuşarak inşa edin — kontrol etmekle değil. Kontrol geçici sakinlik verir, güven kalıcı huzur.",
    tema: "kiskanclık"
  },
  {
    id: "is016",
    metin: "{{ad}}, bu ilişkiye baktım ve şunu fark ettim: ikisi de çok bekliyor, az yapıyor. {{soru}} konusunda beklenti yerine eylem.\n\nGörmek istediğin değişimi sen ol. Öbürünü değiştirmeye çalışma — bu işe yaramaz. Kendini değiştir. Bir insan değiştiğinde, ilişki de değişmeye başlar.",
    tema: "eylem"
  },
  {
    id: "is017",
    metin: "{{ad}}, bu iki insanın arasındaki bağ güçlü ama yorgun. {{soru}} konusunda ilişkinize tatil verin — birbirinden değil, sorunlardan tatil.\n\nBirlikte eğlenin, birlikte nefes alın. Sorunları bir köşeye bırakın ve sadece 'biz' olun — bir gün için bile olsa. O bir gün çok şey yeniler.",
    tema: "dinlenme"
  },
  {
    id: "is018",
    metin: "{{ad}}, bu ilişkide affetme meselesi var. {{soru}} konusunda biri affetmek zorunda — belki ikisi de.\n\nAffetmek için özür beklemeyin her zaman. Bazen sadece kendi huzurunuz için affedersiniz. Affetmek zayıflık değil — ilerlemeyi seçmektir. O yükü bırakın.",
    tema: "affetme"
  },
  {
    id: "is019",
    metin: "{{ad}}, bu iki yüze baktım. {{soru}} konusunda şunu gördüm: bu ilişkide büyük bir potansiyel var — kullanılmamış.\n\nİki insan da daha iyi olabilir, ilişki de. Ama bunun için her ikisinin de istemesi lazım. 'İstiyoruz' sorusunun cevabı ne? O cevap her şeyi belirler.",
    tema: "potansiyel"
  },
  {
    id: "is020",
    metin: "{{ad}}, bu ilişkideki sessizliklere baktım. {{soru}} konusunda bazı sessizlikler huzur, bazıları ağırlık taşır.\n\nBu sessizlik hangisi? Bunu hissedin. Gergin bir sessizlik varsa — doldurun onu. Kelimelerle, gülümsemeyle, bir dokunuşla. Sessizlik bazen koruyucu görünür ama aslında mesafe yaratır.",
    tema: "sessizlik"
  },
  {
    id: "is021",
    metin: "{{ad}}, bu ilişkide biri fedakarlık yapıyor, öbürü fark etmiyor. {{soru}} konusunda fark etmeyen görmek istemiyor belki.\n\nAma fedakarlık görülmezse solar. Görün birbirinizi — gerçekten görün. 'Ne yaptın bugün benim için?' değil, 'ne hissediyorsun?' sorusu daha derin bir görme açar.",
    tema: "fedakarlik"
  },
  {
    id: "is022",
    metin: "{{ad}}, bu iki insanın geleceğine baktım. {{soro}} konusunda birlikte mi, ayrı mı gidecekler? Bunu kesin söyleyemem — bu onların seçimi.\n\nAma şunu söyleyeyim: her iki yolda da hayat devam eder. Önemli olan seçimi bilinçli yapmak — korkudan değil, sevgiden. Korkudan yapılan seçimler pişmanlık doğurur.",
    tema: "gelecek"
  },
  {
    id: "is023",
    metin: "{{ad}}, bu ilişkide birikim var — hem güzel hem ağır. {{soru}} konusunda güzel birikimleri kutlayın, ağır birikimleri konuşarak hafifletin.\n\nİkisi de ilişkinin parçası. Sadece güzeli görmek gerçekçi değil, sadece ağırı görmek ise yıpratıcı. Dengeyi koruyun.",
    tema: "birikim"
  },
  {
    id: "is024",
    metin: "{{ad}}, bu ilişkiye baktım ve şunu gördüm: iki insan da yorulmuş — birbirinden değil, mücadeleden. {{soru}} konusunda mücadeleyi bırakın.\n\nBirbirinize karşı değil, birlikte mücadele edin. 'Sen yaptın' yerine 'biz nasıl çözeriz?' deyin. Hedef ortak olsun — o anda düşman olmaktan çıkıp takım olursunuz.",
    tema: "birliktelik"
  },
  {
    id: "is025",
    metin: "{{ad}}, şunu söyleyeyim: bu ilişki değerli. {{soru}} ne olursa olsun, değerli olan şeyi korumak için çaba gerekir.\n\nKolay olan kaçmak, zor olan kalmak ve çalışmaktır. Ama zor olan daha değerlidir. En güzel ilişkiler emekle büyür — kolaylıkla değil. O emeği verin.",
    tema: "deger"
  }
];